import { useSetAtom } from 'jotai';
import { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { atomProcessingAction } from '@/modules/CampaignsModule/atoms/actionEmailAtom';
import { atomCallbackStep } from '@/modules/CampaignsModule/atoms/actionsAtom';
import { CAMPAIGNS_PATH } from '@/modules/CampaignsModule/constants';
import { useActionSmsData } from '@/modules/CampaignsModule/hooks/useActionSmsData';

const ImmediateDeliveryForm = () => {
  const navigate = useNavigate();
  const { campaignId, actionId } = useParams();

  const setCallbackStep = useSetAtom(atomCallbackStep);
  const setProcessingAction = useSetAtom(atomProcessingAction);

  const { setSmsDelivery } = useActionSmsData(Number(actionId));

  const handleSubmitData = useCallback(async () => {
    setProcessingAction(true);
    await setSmsDelivery();
    navigate(`${CAMPAIGNS_PATH}/${Number(campaignId)}/sms/${Number(actionId)}/summary`);
    setProcessingAction(false);
  }, [actionId, campaignId, navigate, setProcessingAction, setSmsDelivery]);

  useEffect(() => {
    setCallbackStep(() => handleSubmitData);
  }, [handleSubmitData, setCallbackStep]);

  return null;
};

export default ImmediateDeliveryForm;
